import { isEmpty } from 'underscore';
import { componentsConfig } from './component-config';
import { getComponentByType } from './site-config-reader';


const SPECIAL_NAV_MAPPING = {
  [componentsConfig.introduction.type]: componentsConfig.header.type,
};

export const navigateToEditingComponent = (id, type, siteConfig) => {
  let elementId = id;

  if (SPECIAL_NAV_MAPPING[type]) {
    const component = getComponentByType(siteConfig, SPECIAL_NAV_MAPPING[type]);
    if (!isEmpty(component)) {
      elementId = component.id;
    }
  }

  const element = document.getElementById(elementId);

  if (element && element.scrollIntoView) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
